import PageMeta from "../../components/common/PageMeta";
import { useEffect, useState } from "react";
import Spinner from "../../components/ui/Spinner";
import {
  API_BASE_URL,
  DEFAULT_PAGE_DESCRIPTION,
  DEFAULT_PAGE_TITLE,
  DEFAULT_PER_PAGE,
} from "../../utilities/constants";
import { NavLink, useLocation, useNavigate } from "react-router";
import Pagination from "../../components/ui/Pagination";
import useQueryParams from "../../hooks/useQueryParams";
import { handleApiCall, jsonToQueryParams } from "../../utilities/helper";
import { FaCheckCircle, FaClock, FaTimesCircle } from "react-icons/fa";
import ButtonText from "../../components/ui/button/ButtonText";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";

const TemplatePage = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { queryParams } = useQueryParams();
  const pageNo = queryParams.get("pageNo") || 0;
  const pageSize = queryParams.get("pageSize") || DEFAULT_PER_PAGE;
  const sortOrder = queryParams.get("sortOrder") || "DESC";;
  const [controller, setController] = useState(null);

  const callListApi = async () => {
    controller?.abort();
    const newController = new AbortController();
    setController(newController);
    const { signal } = newController;
    setLoading(true);
    try {
      const query = jsonToQueryParams({
        keyword: queryParams.get("search") || "",
      });
      const response = await handleApiCall(
        `${API_BASE_URL}/api/1.0.0/template?pageNo=${pageNo}&pageSize=${pageSize}&sortBy=createdAt&sortOrder=${sortOrder}&keyword=${query}`,
        {
          method: "GET"
        },
        null,
        signal
      );
      if (response.responseStatus == true) {
        setData(response.data);
      } else {
        setData(null);
      }
      if (response.responseCode !== 299) {
        setLoading(false);
      }
    } catch (e) {
      console.error("Error", e);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    callListApi();
  }, [location.search]);

  return (
    <>
      <PageMeta
        title={`Templates - ${DEFAULT_PAGE_TITLE}`}
        description={`Templates - ${DEFAULT_PAGE_DESCRIPTION}`}
      />
      <div className="flex justify-between items-center mb-6">
        <PageBreadcrumb
          pageTitle="Template"
        />
        <ButtonText
          title='+ Add New'
          onClick={() => { navigate('/add-template') }}
        />
      </div>

      {loading ? (
        <div className="flex justify-center items-center">
          <Spinner />
        </div>
      ) : (
        <div className="space-y-6">
          <div className="relative overflow-x-auto sm:rounded-lg">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 rounded-lg">
              <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    Name
                  </th>

                  <th scope="col" className="px-6 py-3">
                    Subject
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Body
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Status
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.data.map((user, index) => (
                  <tr key={index} className="border-b dark:border-gray-600 text-sm text-gray-700 dark:text-gray-300">
                    <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                      <div className="flex items-center gap-2">
                        <span
                          className="max-w-[120px] block truncate"
                          title={`${user?.name || ""}`.trim()}
                        >
                          {(() => {
                            const Names = `${user?.name || ""}`.trim();
                            return Names.length > 25 ? Names.slice(0, 25) + "…" : Names;
                          })()}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4">{user?.subject}</td>
                    <td className="px-6 py-4">{user?.body}</td>
                    <td className="px-6 py-4">
                      <div
                        className={`flex items-center gap-2 text-xs px-3 py-1 rounded-full w-fit
                            ${user?.statusId === 1
                            ? 'bg-green-100 text-success-700'
                            : user?.statusId === 2
                              ? 'bg-red-100 text-red-700'
                              : 'bg-yellow-100 text-yellow-700'
                          }`}
                      >
                        {user?.statusId === 1 && <FaCheckCircle className="text-success-500" />}
                        {user?.statusId === 2 && <FaTimesCircle className="text-red-500" />}
                        {user?.statusId === 3 && <FaClock className="text-yellow-600" />}
                        {user?.statusId === 1 ? "Active" : "Inactive"}
                      </div>
                    </td>
                    <td className="px-6 py-4 flex gap-5">
                      <NavLink to={`/template-details/${user?.id}`}>
                        <button
                          type="submit"
                          className="bg-yellow-600 text-white px-6 py-2 rounded-md hover:bg-yellow-700 transition"
                        >
                          View
                        </button>
                      </NavLink>

                      <NavLink to={`/edit-template/${user?.id}`} state={{ user: user }}>
                        <button
                          type="buttton"
                          className="edit-button"
                        >
                          Edit
                        </button>
                      </NavLink>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <div className='flex justify-center items-center'>
        <Pagination
          pageParam="pageNo"
          currentPage={data?.pageNo + 1}
          totalElements={data?.totalRecords}
        />
      </div>
    </>
  );
};
export default TemplatePage;
